import { Box, Center, Loader, Stack, Text } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import { fetchUpcomingBirthdays } from '../../shared/api/project-crm'
import { BirthdayCard } from './birthday-card'

/**
 * Per-project ДР tab — фильтр глобального /birthdays/upcoming по project.id.
 * Глобальный список в /birthdays (B-S6). Здесь — только этот проект.
 */
export function BirthdaysTab({ projectId }: { projectId: string }) {
  const { data, isLoading } = useQuery({
    queryKey: ['birthdays'],
    queryFn: () => fetchUpcomingBirthdays(365), // окно год — для project-таба показываем всех
  })

  if (isLoading) {
    return (
      <Center mih={200}>
        <Loader />
      </Center>
    )
  }

  // project null у сотрудников (#6 юнион) — в таб проекта попадают только контакты этого проекта.
  const own = (data ?? []).filter((b) => b.project?.id === projectId)

  if (own.length === 0) {
    return (
      <Box>
        <Text c="dimmed" size="sm">
          У контактов этого проекта не задана дата рождения, либо все ДР дальше года.
          Добавь birthday в карточку контакта во вкладке «Контакты».
        </Text>
      </Box>
    )
  }

  return (
    <Stack gap="sm">
      <Text size="sm" c="dimmed">
        Все ДР проекта в порядке ближайших к сегодняшнему дню:
      </Text>
      {own.map((b) => (
        <BirthdayCard key={b.subject_id} item={b} showProject={false} />
      ))}
    </Stack>
  )
}
